interface IConfig {
    baseUrl: string;
}

const isDevelopment = process.env.NODE_ENV === "development";

export const Config: IConfig = {
    baseUrl: isDevelopment ? "http://localhost:5001" : `${window.location.protocol}//${window.location.host}`,
};